import React from 'react';
import Text from './Text';
import getThemeLookup from '../selectors/getThemeLookup';
import { TEXT_PROPERTIES } from '../utils/theme';
import { useAppSelector } from '../app/hooks';
import combineStyles from '../utils/combineStyles';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import TouchableOpacity from './TouchableOpacity';
import { styled } from '@mui/system';
import SubSectionChevron from './SubSectionChevron';

/**
 * # SectionHeading
 *
 * @param title
 * @param textStyle
 * @param containerStyle
 */
const SectionHeading = ({
  title,
  textStyle,
  containerStyle,

  collapsed,
  collapsedIconAction,
}: {
  title: string;
  textStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  animated?: boolean;

  collapsed?: boolean;
  collapsedIconAction?: () => void;
}) => {
  const p = useAppSelector(getThemeLookup);
  const isMobile = useAppSelector(getDeviceTypeMobile);

  return (
    <TouchableOpacity
      onClick={collapsedIconAction}
      style={combineStyles(styles.container, isMobile && styles.containerMobile, containerStyle)}
    >
      <div style={styles.textWrapper}>
        <Text
          variant="body2"
          style={combineStyles(
            p('defaultText', TEXT_PROPERTIES),
            p('sectionTitle', TEXT_PROPERTIES),
            p('sectionHeading', TEXT_PROPERTIES),
            textStyle,
          )}
        >
          {title}
        </Text>
      </div>

      <ArrowDown>
        {Boolean(collapsedIconAction) && (
          <div className={`arrow-down ${collapsed && 'collapsed'}`}>
            <SubSectionChevron />
          </div>
        )}
      </ArrowDown>
    </TouchableOpacity>
  );
};

export default SectionHeading;

const styles: Styles = {
  container: {
    padding: '25px 50px 8px',
    flex: 1,
    width: '100%',
    gap: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    display: 'flex',
  },
  containerMobile: {
    padding: '20px 30px 8px',
  },
  textWrapper: { flex: 1 },
};

const ArrowDown = styled(TouchableOpacity)(() => {
  return {
    marginRight: 20,

    '.arrow-down': {
      translate: '0 45px',
      rotate: '0deg',
      opacity: 0,
      transition:
        'all 300ms cubic-bezier(0.95, 0.07, 0, 0.92), opacity 400ms cubic-bezier(0.95, 0.07, 0, 0.92)',
    },

    '.arrow-down.collapsed': {
      translate: '0 4px',
      rotate: '-90deg',
      opacity: 1,
      transition:
        'all 300ms cubic-bezier(0.95, 0.07, 0, 0.92), opacity 1ms cubic-bezier(0.95, 0.07, 0, 0.92)',
    },
  };
});
